import { isProfileCompleted } from "../../../../utils";

export const getStatus = (
  profileUser: any,
  status: number,
  accountStatus: number,
  _id: string,
  hasSubjects: boolean = true,
  profileDisabled?: boolean,
  adminDisabled?: boolean
) => {
  if (!_id) {
    return "Not Created";
  }

  if (adminDisabled) {
    return "Disabled by admin";
  }

  if (profileDisabled) {
    return "Hidden"; // Self-disabled
  }

  // Check if user has been approved by admin
  if (status === 1 && accountStatus === 1) {
    return "Live";
  }
  // Check if user is not approved yet
  if (status === 0 && accountStatus === 0) {
  
    if (isProfileCompleted(profileUser, hasSubjects) && !profileUser?.isSubmitted) {
      return "Completed";
    } else if (profileUser?.isSubmitted) {
      return "Pending admin review";
    } else if (!profileUser?.isSubmitted) {
      return "Draft";
    }
  }

  // Default case: treat as Draft rather than Unknown
  return "Draft";
};
